import { AllInProps } from './AllIn'
import { AppPermissionProps } from './AppPermission'
import { BuyChipProps } from './BuyChip'
import { EndPracticeGameProps } from './EndPracticeGame/EndPracticeGame'
import { GameDeleteProps } from './GameDelete'
import { JoinCallProps } from './JoinCall'
import { RoundWinnerProps } from './RoundWinner'
import { ThreeCardLeaveConfirmProps } from './ThreeCardLeaveConfirm/ThreeCardLeaveConfirm'
import { ThreeCardStartProps } from './ThreeCardStart/ThreeCardStart'
import { RemovedByTeacherProps } from './RemovedByTeacher/RemovedByTeacher'

export type BaseModalConfig = {
  onClose: () => void
  timeToKeepOpen?: number
}

export type ModalContentConfig = { dismissOnBackdrop?: boolean } & (
  | { kind: 'handWinnersModal'; props: RoundWinnerProps }
  | { kind: 'allIn'; props: AllInProps }
  | { kind: 'options'; props: JoinCallProps }
  | { kind: 'buy'; props: BuyChipProps }
  | { kind: 'gameDeleted'; props: GameDeleteProps }
  | { kind: 'endPracticeGame'; props: EndPracticeGameProps }
  | { kind: 'threeCardStart'; props: ThreeCardStartProps }
  | { kind: 'threeCardLeaveConfirm'; props: ThreeCardLeaveConfirmProps }
  | { kind: 'appPermission'; props: AppPermissionProps }
  | { kind: 'removedByTeacher'; props: RemovedByTeacherProps }
)

export * from './AllIn'
export * from './RoundWinner'
export * from './GameDelete'
export * from './BuyChip'
export * from './JoinCall'
export * from './ThreeCardStart'
export * from './ThreeCardLeaveConfirm'
export * from './AppPermission'
export * from './RemovedByTeacher'
